<template>
  <section :id="id ? `ss-${id}` : null" class="ui-card ss-card" :class="[tone ? `ss-card--${tone}` : '', { 'is-flash': id && ctl.ui.flash === id }]">
    <!-- div, ne header: aplikacija ima globalno pravilo `header { height: 64px !important }` -->
    <div v-if="title || $slots.right" class="ss-card__h">
      <div class="ss-card__t">
        <h3 v-if="title">{{ title }}</h3>
        <p v-if="desc">{{ desc }}</p>
      </div>
      <slot name="right"></slot>
    </div>
    <div class="ss-card__b"><slot></slot></div>
  </section>
</template>

<script>
/** Kartica ekrana: naslov, kratak opis i sadržaj. `id` je sidro za rezultate pretrage. */
export default {
  name: "SetCard",
  inject: { ctl: "settingsCtl" },
  props: {
    id: { type: String, default: "" },
    title: { type: String, default: "" },
    desc: { type: String, default: "" },
    tone: { type: String, default: "" },
  },
};
</script>
